import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGoogleAuthenticationLogin, setGoogleAuthenticationLogout } from "./store/slice/authenticationSlice";
import { useValidateUserAndGetDetailsQuery } from "../src/store/api/orderApi";
import { useGoogleLogin } from '@react-oauth/google';
import Spinner from 'react-bootstrap/Spinner';


const GoogleLoginComponent = () => {

  const dispatch = useDispatch();
  const authentication = useSelector((state) => state.authentication);
  const userInfo = useSelector((state) => state.authentication.userInfo);
  const [isLoading, setIsLoading] = useState(false);
  let availablePoints = 0.00;
  const { data: userData } = useValidateUserAndGetDetailsQuery(userInfo.emailId, { skip: userInfo.emailId ? false : true });
  if (userData && userData.userAvailablePoints) {
    availablePoints = parseFloat(userData.userAvailablePoints).toFixed(0);
  }

  //new login
  const login = useGoogleLogin({
    onSuccess: tokenResponse => {
      console.log(tokenResponse);
      setIsLoading(true);
      fetch("https://www.googleapis.com/oauth2/v1/userinfo?access_token=" + tokenResponse.access_token)
        .then(response => response.json())
        .then(response => {

          let userInfo = {
            name: response.name,
            emailId: response.email, // "ITAdmin@dummy.com"
          };
          console.log(userInfo);
          sessionStorage.setItem("token", response.tokenId);

          dispatch(setGoogleAuthenticationLogin({ userInfo, isLoggedIn: true }));

          setIsLoading(false);
        })
        .catch((error) => { console.log(error); isLoading(false) })
    },
  });
  //end new login

  // Logout Session and Update State
  const logout = () => {
    dispatch(setGoogleAuthenticationLogout());
  };

  return (
    <div>
      {
        isLoading &&
        <div className="spinner">
          <Spinner animation="border" />
        </div>
      }
      <div>
        {authentication.isLoggedIn ? (
          <div style={{ marginLeft: "0.5rem" }}>
            <label style={{ marginBottom: "0.5rem" }}>
              Welcome {authentication.userInfo.name} &nbsp;&nbsp;&nbsp;
            </label>
            <div>
              <label style={{ marginBottom: "0.5rem" }}>
                Available points:  {availablePoints}
              </label>
            </div>

            <button style={{ fontSize: "15px", padding: "10px 25px", borderRadius: "4px", cursor: "pointer", backgroundColor: "#ffffff", border: "1px solid #3e5175" }} onClick={() => logout()}>Logout</button>

          </div>
        ) :
          (
            <button style={{ fontSize: "15px", padding: "10px 25px", borderRadius: "4px", cursor: "pointer", backgroundColor: "#ffffff", border: "1px solid #3e5175" }} onClick={() => login()}>Login with Google</button>
          )
        }
      </div>
    </div>
  );
}
export default GoogleLoginComponent;